"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueChange = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./ValueChange.css"));
var _MortageRateChangeModal = require("../MortageRateChangeModal");
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _trackChangeRateInfoClick = require("../../tracking/trackChangeRateInfoClick");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ValueChange = props => {
  const {
    valueChange,
    value
  } = props;
  const [open, setOpen] = React.useState(false);
  const onClick = React.useCallback(() => {
    (0, _trackChangeRateInfoClick.trackChangeRateInfoClick)();
    setOpen(true);
  }, []);
  const [hovered, setHovered] = React.useState(false);
  const onHover = React.useCallback(() => {
    if (hovered) {
      return;
    }
    (0, _trackChangeRateInfoClick.trackChangeRateInfoClick)();
    setHovered(true);
  }, [hovered]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style['value-change']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, value), /*#__PURE__*/React.createElement(_icons.IconActionArrowRight16, {
    color: "icon-main-default"
  }), /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, valueChange.newValue), valueChange.dialog && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_uiKit.Tooltip, {
    title: /*#__PURE__*/React.createElement("div", {
      className: style['tooltip']
    }, /*#__PURE__*/React.createElement(_uiKit.ArticleHeading4, null, valueChange.dialog.title), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
      whiteSpace: "pre-wrap"
    }, valueChange.dialog.description)),
    theme: "white",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner'],
    onMouseEnter: onHover
  }, /*#__PURE__*/React.createElement(_icons.IconFunctionalInformation16, {
    color: "icon-main-default"
  })))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner'],
    onClick: onClick
  }, /*#__PURE__*/React.createElement(_icons.IconFunctionalInformation16, {
    color: "icon-main-default"
  }))))), /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default"
  }, valueChange.subtitle), valueChange.dialog && open && /*#__PURE__*/React.createElement(_MortageRateChangeModal.MortageRateChangeModal, {
    open: open,
    onOpenChange: setOpen,
    title: valueChange.dialog.title,
    description: valueChange.dialog.description
  }));
};
exports.ValueChange = ValueChange;